import { BTAvatar, btAvatarColorize } from "@btnet/core-components";

import { type ParticipantData } from "commonComponents/entity/discussion/DiscussionContainer/DiscussionContainer.api.types";

interface ICommentParticipantsListProps {
    participants?: ParticipantData[];
}

export function CommentParticipantsList({ participants }: ICommentParticipantsListProps) {
    if (!participants) {
        return null;
    }
    return (
        <div className="CommentParticipantsList">
            {participants.map((p) => (
                <ParticipantDisplay key={p.userId} participant={p} />
            ))}
        </div>
    );
}

interface IParticipantDisplayProps {
    participant: ParticipantData;
}

function ParticipantDisplay({ participant: p }: IParticipantDisplayProps) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
            }}
            key={p.userId}
        >
            <BTAvatar
                testid={`participant-avatar-${p.userId}`}
                colorize={btAvatarColorize[p.userId % btAvatarColorize.length]}
                text={p.name}
                size="sm"
            />
            {p.name}
        </div>
    );
}
